export default __webpack_public_path__ + "static/media/print-label-third-position.535ea461.svg";